import React from 'react';
import { AddCustomBlockButton } from 'components/v2/buttons/AddCustomBlockButton';
import { useAddToolVersionMutation } from 'services/api/adminToolsQueriesAndMutations';

interface Props {
  toolId: string;
}

const AdminEditToolAddVersionButton: React.FC<Props> = ({ toolId }) => {
  const addVersionMutation = useAddToolVersionMutation(toolId);

  const handleClick = () => {
    addVersionMutation.mutate();
  };

  return <AddCustomBlockButton caption="Add version" onClick={handleClick} />;
};

export default AdminEditToolAddVersionButton;
